import type { UserRole } from '@/types/auth';
import { aliasMabarToEventHref } from '@/utils/appDeepLink';
import { CUSTOMER_PATH_PREFIXES } from '@/utils/clientPaths';

const ROLE_PREFIX: Record<UserRole, string[]> = {
  customer: [...CUSTOMER_PATH_PREFIXES],
  community: ['/host'],
  owner: ['/admin'],
  staff: ['/admin'],
  superadmin: ['/superadmin'],
};

export function parseReturnUrl(raw: string | null): string | null {
  if (!raw) return null;
  try {
    const decoded = decodeURIComponent(raw.trim());
    if (decoded.startsWith('/')) return aliasMabarToEventHref(decoded);
    const lpUrl = import.meta.env.VITE_LP_URL;
    if (lpUrl && decoded.startsWith(lpUrl)) return decoded;
    if (decoded.startsWith('https://sporto.id') || decoded.startsWith('http://localhost:3000')) return decoded;
    return null;
  } catch {
    const trimmed = raw.trim();
    if (trimmed.startsWith('/')) return aliasMabarToEventHref(trimmed);
    const lpUrl = import.meta.env.VITE_LP_URL;
    if (lpUrl && trimmed.startsWith(lpUrl)) return trimmed;
    return null;
  }
}

export function validateReturnUrl(path: string | null, role: UserRole): string | null {
  const normalized = parseReturnUrl(path);
  if (!normalized || normalized.startsWith('//')) return null;
  if (normalized.startsWith('http://') || normalized.startsWith('https://')) {
    const lpUrl = import.meta.env.VITE_LP_URL;
    if (lpUrl && normalized.startsWith(lpUrl)) return normalized;
    if (normalized.startsWith('https://sporto.id') || normalized.startsWith('http://localhost:3000')) return normalized;
    return null;
  }
  const allowed = ROLE_PREFIX[role];
  return allowed.some((p) => normalized === p || normalized.startsWith(`${p}/`))
    ? normalized
    : null;
}
